// extracted by mini-css-extract-plugin
module.exports = {"root":"FormItem_root__p32u6","inline":"FormItem_inline__3MDvY"};